"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx } from "react/jsx-runtime";
import Account from "../../api/account";
import Auth from "../../util/auth";
import PodCheckReasonModal, {
  PodCheckReasonContent
} from "./pod_check_reason_modal";
import PodUncheckReasonModal, {
  PodUncheckReasonContent
} from "./pod_uncheck_reason_modal";
import { getLoadRelationshipForDocument } from "../helpers/document_load_relationship_helpers";
import {
  DocumentReferenceMatchDisposition,
  ManualPODMarkReasonCode
} from "../data/types/Pb";
import { POD_CHECK_POSITIVE_LABELS } from "./pod_checks";
function wasManualPodMark(doc) {
  var _a;
  return ((_a = doc.data) == null ? void 0 : _a.includesPODMarkSource) === "documents_api";
}
function isManagedIndexer() {
  const currentUser = Auth.getCurrentUser();
  return !!currentUser.managed_indexer;
}
function shouldShowModalToCurrentUser() {
  const featureFlagEnabled = !!Account.currentSettings().show_pod_check_modal_to_auditors;
  if (featureFlagEnabled) {
    return true;
  }
  return isManagedIndexer();
}
export function shouldShowAutomationSectionToCurrentUser() {
  return isManagedIndexer();
}
export function shouldShowPodUncheckModal(currentIsPod, newIsPod) {
  return currentIsPod && !newIsPod && shouldShowModalToCurrentUser();
}
export function shouldShowPodCheckModal(currentIsPod, newIsPod) {
  return !currentIsPod && newIsPod && shouldShowModalToCurrentUser();
}
function deriveModalProps(doc, loadState, documentLoadRelationships) {
  var _a, _b, _c, _d;
  const checkbox = document.getElementById("use-as-pod");
  const anchorRect = checkbox ? checkbox.getBoundingClientRect() : null;
  const relationship = getLoadRelationshipForDocument(
    doc,
    loadState,
    documentLoadRelationships
  );
  const hasReferenceMatch = relationship ? relationship.reference_match_disposition === DocumentReferenceMatchDisposition.DocumentReferenceMatchDispositionKnownMatch : (_a = doc.has_reference_number) != null ? _a : null;
  return {
    anchorRect,
    document: doc,
    accountSettings: Account.currentSettings(),
    hasReferenceMatch,
    wasManuallyMarked: wasManualPodMark(doc),
    matchedReferenceValues: (_b = relationship == null ? void 0 : relationship.matched_reference_values) != null ? _b : [],
    loadReferences: (_d = (_c = loadState == null ? void 0 : loadState.load) == null ? void 0 : _c.references) != null ? _d : {}
  };
}
export function renderPodUncheckReasonModal({
  onClose,
  onSubmit,
  doc,
  loadState,
  documentLoadRelationships
}) {
  const modalProps = deriveModalProps(
    doc,
    loadState,
    documentLoadRelationships
  );
  if (isManagedIndexer()) {
    return /* @__PURE__ */ jsx(
      PodUncheckReasonModal,
      __spreadValues({
        onClose,
        onSubmit
      }, modalProps)
    );
  }
  const checks = [
    {
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeSignature,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeSignature],
      indicator: "pass",
      preChecked: true
    },
    {
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoDamages,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoDamages],
      indicator: "pass",
      preChecked: true
    },
    {
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoCarrierRate,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoCarrierRate],
      indicator: "pass",
      preChecked: true
    }
  ];
  if (modalProps.accountSettings.pod_requires_bol_validation) {
    checks.push({
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeOneReferenceMatch,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeOneReferenceMatch],
      indicator: "pass",
      preChecked: true
    });
  }
  return /* @__PURE__ */ jsx(
    PodUncheckReasonContent,
    {
      checks,
      onClose,
      onSubmit,
      anchorRect: modalProps.anchorRect,
      showAutomationSection: shouldShowAutomationSectionToCurrentUser()
    }
  );
}
export function renderPodCheckReasonModal({
  onClose,
  onSubmit,
  doc,
  loadState,
  documentLoadRelationships
}) {
  const modalProps = deriveModalProps(
    doc,
    loadState,
    documentLoadRelationships
  );
  if (isManagedIndexer()) {
    return /* @__PURE__ */ jsx(
      PodCheckReasonModal,
      __spreadValues({
        onClose,
        onSubmit
      }, modalProps)
    );
  }
  const checks = [
    {
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeSignature,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeSignature],
      indicator: "fail",
      preChecked: false
    },
    {
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoDamages,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoDamages],
      indicator: "fail",
      preChecked: false
    },
    {
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoCarrierRate,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoCarrierRate],
      indicator: "fail",
      preChecked: false
    }
  ];
  if (modalProps.accountSettings.pod_requires_bol_validation) {
    checks.push({
      code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeOneReferenceMatch,
      label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeOneReferenceMatch],
      indicator: "fail",
      preChecked: false
    });
  }
  return /* @__PURE__ */ jsx(
    PodCheckReasonContent,
    {
      checks,
      onClose,
      onSubmit,
      anchorRect: modalProps.anchorRect,
      showAutomationSection: shouldShowAutomationSectionToCurrentUser(),
      isManagedIndexer: false
    }
  );
}
